<template>
  <page-header
    :breadcrumRoutes="routes"
    title="Formulario baja de cargas masiva"
  />
  <a-form
    name="form"
    layout="vertical"
    ref="formRef"
    :model="formState"
    :rules="rules"
    @finish="onSubmit"
  >
    <a-card class="mt-2">
      <a-row class="mb-2">
        <a-col>
          <a-typography-title class="text-gray-8" :level="4">
            Datos corporativos
          </a-typography-title>
        </a-col>
      </a-row>
      <a-row :gutter="16" type="flex">
        <a-col :md="8" :xs="24">
          <a-form-item label="Empresa" has-feedback name="company">
            <select-ordered
              v-model="formState.company"
              optionFilterProp="label"
              placeholder="Selecciona una empresa"
              :options="companiesData"
              @change="handleChangeCompany"
            />
          </a-form-item>
        </a-col>
        <a-col :md="8" :xs="24">
          <a-form-item label="Aseguradora" has-feedback name="insuranceCompany">
            <select-ordered
              v-model="formState.insuranceCompany"
              placeholder="Selecciona una aseguradora"
              :options="insurancesData"
              :disabled="insurancesData.length < 1"
              @change="handleChangeInsurance"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-card>
    <a-row :gutter="[16, 8]" type="flex" class="mt-2">
      <a-col :md="12" :xs="24">
        <a-card style="min-height: 300px">
          <a-row>
            <a-col>
              <a-typography-title class="text-gray-8" :level="4">
                Mensaje a compañía aseguradora
              </a-typography-title>
            </a-col>
          </a-row>
          <a-form-item
            has-feedback
            label="Escribe un mensaje para la compañía aseguradora"
            name="message"
          >
            <a-textarea
              v-model:value="formState.message"
              placeholder="Escribe Aquí..."
              :rows="6"
            />
          </a-form-item>
        </a-card>
      </a-col>
      <a-col :md="12" :xs="24">
        <a-card>
          <a-row :gutter="16">
            <a-col :span="24">
              <a-typography-title class="text-gray-8" :level="4">
                Adjuntar archivo
              </a-typography-title>

              <a-form-item
                label="Adjunta un documento excel con el listado de asegurados y sus cargas acorde al formato"
                name="fileList"
              >
                <a
                  v-if="formState.insuranceCompany"
                  :href="documentURL"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Descargar formato
                </a>
                <a-upload-dragger
                  class="mt-3"
                  v-model:file-list="formState.fileList"
                  name="fileList"
                  :remove="handleRemove"
                  :before-upload="beforeUpload"
                  @change="
                    (info) => console.log('Cambio en a-upload-dragger:', info)
                  "
                  accept=".xls,.xlsx"
                >
                  <p class="ant-upload-drag-icon">
                    <upload-outlined />
                  </p>

                  <div class="ant-upload-text fs-6 text-gray-9">
                    Haz click o arrastra aquí el archivo para cargarlo
                  </div>
                </a-upload-dragger>
              </a-form-item>
            </a-col>
            <a-col :span="18">
              <a-form-item name="optionalFiles" label="Archivos opcionales">
                <a-upload
                  :file-list="formState.optionalFiles"
                  :multiple="true"
                  :remove="handleRemoveOptional"
                  :before-upload="beforeUploadOptional"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                >
                  <a-button>
                    <upload-outlined />
                    Subir Archivo
                  </a-button>
                </a-upload>
              </a-form-item>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
    <a-row>
      <a-form-item class="mt-4">
        <a-button
          size="large"
          class="px-4"
          type="primary"
          block
          @click="showModal"
          :disabled="!showNext"
        >
          Siguiente
        </a-button>
      </a-form-item>
    </a-row>
  </a-form>

  <a-modal
    :wrapClassName="'modal-xs'"
    v-model:visible="visible"
    :title="modalStyle.title"
    @ok="handleOk"
    centered
    :closable="!loading"
    :maskClosable="false"
  >
    <a-typography-title class="text-gray-4 fw-regular mb-2" :level="5">
      {{ modalStyle.text }}
    </a-typography-title>
    <template #footer>
      <a-row type="flex" justify="end">
        <a-col>
          <a-space>
            <a-button @click="handleOk" :disabled="loading">
              {{ modalStyle.cancelText }}
            </a-button>
            <a-button
              key="submit"
              type="primary"
              @click="onSubmit"
              :loading="loading"
            >
              {{ modalStyle.confirmText }}
            </a-button>
          </a-space>
        </a-col>
      </a-row>
    </template>
  </a-modal>
  <template v-if="showSucess">
    <a-modal
      :wrapClassName="'modal-xs'"
      v-model:visible="showSucess"
      centered
      footer=""
      :maskClosable="false"
    >
      <a-result
        status="success"
        title="Solicitud enviada"
        :sub-title="modalStyle.successText"
      >
        <template #extra>
          <router-link
            class="justify-content-center d-flex"
            :to="{
              name: 'BajaCargasMasivaDetalle',
              params: { id: createdTicketId }
            }"
          >
            <a-button key="console" type="primary">Ver ticket</a-button>
          </router-link>
        </template>
      </a-result>
    </a-modal>
  </template>
  <a-modal
    :wrapClassName="'modal-xs'"
    v-model:visible="showReport"
    @cancel="onCloseReport"
    centered
    :maskClosable="false"
  >
    <template #title>
      <div style="display: flex; align-items: center; gap: 8px">
        <warning-outlined style="font-size: 24px; color: #ff4d4f" />
        <a-typography-text strong style="color: #475569">
          Problemas en el movimiento
        </a-typography-text>
      </div>
    </template>

    <a-row :gutter="12">
      <a-col :span="24">
        <a-typography-paragraph class="mb-3">
          Se detectaron problemas durante el movimiento.
          <br />
          Puedes
          <a-typography-text strong>descargar un reporte</a-typography-text>
          con el detalle de cada registro en la columna
          <a-typography-text strong>'OBSERVACION'</a-typography-text>
          .
        </a-typography-paragraph>

        <a-typography-paragraph class="mb-3">
          <a-typography-text strong>Importante:</a-typography-text>
          <br />
          Este movimiento se intentó realizar
          <a-typography-text strong>hacia la Compañía,</a-typography-text>
          al fallar:
        </a-typography-paragraph>

        <ul class="ml-3 p-0">
          <li>
            <a-typography-text strong type="primary">
              No se envió
            </a-typography-text>
            ningún correo electrónico.
          </li>
          <li>
            <a-typography-text strong type="primary">
              No se creó
            </a-typography-text>
            ningún subticket.
          </li>
        </ul>

        <a-typography-text type="secondary" style="display: block" class="mt-4">
          Este ticket quedará como
          <a-typography-text strong type="danger">FALLIDO</a-typography-text>
          en el listado de tickets masivos.
        </a-typography-text>
      </a-col>
    </a-row>

    <template #footer>
      <router-link
        class="ml-2 mr-2"
        :to="{
          name: 'BajasCargas',
          hash: '#massive'
        }"
      >
        <a-button type="default">Ver listado de tickets</a-button>
      </router-link>
      <a-button
        v-if="!loadingReport"
        type="primary"
        @click="downloadReport"
        :loading="loadingReport"
      >
        Descargar reporte
      </a-button>
    </template>
  </a-modal>
</template>

<script>
// Components
import { getMovementProcessedFile } from '@/network';
import { UploadOutlined, WarningOutlined } from '@ant-design/icons-vue';
import PageHeader from '@/components/page-header.vue';
import SelectOrdered from '@/bewell-components/form-controls/select-ordered.vue';
import { reactive, ref, computed } from 'vue';
import { useStore } from 'vuex';
import { message } from 'ant-design-vue';
// Store
import {
  GET_LOGGED_USER,
  FETCH_AM_COMPANIES,
  GET_AM_COMPANIES,
  FETCH_AM_INSURANCES,
  GET_AM_INSURANCES,
  ACTION_GET_INSURANCE_COMPANIES_RUTS,
  FETCH_MASSIVE_DEPENDENTS_EXCLUSION_URL,
  GET_MASSIVE_DEPENDENTS_EXCLUSION_URL,
  POST_MASSIVE_DEPENDENTS_EXCLUSION
} from '@/store/types';

// Utils
import openNotificationWithIcon from '@/utils/notifications';
import delay from '@/utils/delay';

const routes = [
  {
    path: '/bajas-cargas',
    breadcrumbName: 'Bajas cargas'
  },
  {
    breadcrumbName: 'Masiva'
  }
];

export default {
  name: 'BajaCargasMasiva',
  components: {
    'page-header': PageHeader,
    'upload-outlined': UploadOutlined,
    'select-ordered': SelectOrdered,
    'warning-outlined': WarningOutlined
  },

  setup() {
    const store = useStore();
    //* Get Data
    const companiesData = ref([]);
    const dataOutput = ref('');
    const getCompanies = async () => {
      await store
        .dispatch(FETCH_AM_COMPANIES)
        .catch((err) =>
          openNotificationWithIcon(
            'error',
            'Error',
            `Error al cargar Empresas. ${err.response.data.message}`
          )
        );
      companiesData.value = await store.getters[GET_AM_COMPANIES];
    };
    getCompanies();

    const insurancesData = ref([]);
    const insurancesConstRuts = ref({});

    const setConstInsurancesRuts = async () => {
      const fetchedRuts = await store.dispatch(
        ACTION_GET_INSURANCE_COMPANIES_RUTS
      );
      insurancesConstRuts.value = fetchedRuts;
    };
    setConstInsurancesRuts();

    const handleChangeCompany = async (value) => {
      try {
        await store.dispatch(FETCH_AM_INSURANCES, value);
      } catch (err) {
        openNotificationWithIcon(
          'error',
          'Error',
          `Error al cargar Compañías Aseguradoras. ${
            err.response?.data?.message || err.message
          }`
        );
      }
      formState.insuranceCompany = null;
      formRef.value.resetFields(['insuranceCompany']);

      documentsData.value = [];
      insurancesData.value = await store.getters[GET_AM_INSURANCES];
    };

    const documentURL = ref(null);
    const documentsData = ref([]);
    const showNext = ref(true);

    const handleChangeInsurance = async () => {
      if (!formState.insuranceCompany) return;
      if (!formState.company) return;

      await store
        .dispatch(FETCH_MASSIVE_DEPENDENTS_EXCLUSION_URL, {
          companyId: formState.company,
          insuranceCompanyId: formState.insuranceCompany
        })
        .catch((err) =>
          openNotificationWithIcon(
            'error',
            'Error',
            `Error al cargar Documento. ${err.response.data.message}`
          )
        );
      documentURL.value = null;
      documentURL.value = store.getters[GET_MASSIVE_DEPENDENTS_EXCLUSION_URL];
    };

    //* Form
    const formRef = ref();
    const formState = reactive({
      typeForm: '1',
      brokerId: store.getters[GET_LOGGED_USER].id,
      company: null,
      insuranceCompany: null,
      message:
        'A través del presente correo, solicitamos la baja masiva de cargas para los RUTs detallados en el documento adjunto.',
      fileList: [],
      optionalFiles: []
    });

    const loading = ref(false);

    //* Docs Logic
    const handleRemove = () => {
      formState.fileList = [];
    };

    const beforeUpload = (file) => {
      const isExcel =
        file.type === 'application/vnd.ms-excel' ||
        file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      if (!isExcel) {
        openNotificationWithIcon(
          'error',
          'Error',
          `${file.name} no es un archivo Excel válido (.xls o .xlsx). \nPor favor selecciona otro archivo.`
        );
      }
      const fileSize = file.size / 1024 / 1024;
      if (fileSize > 5) {
        message.error('El archivo excede el peso máximo 5MB');
      } else {
        formState.fileList[0] = file;
      }
      return false;
    };

    // Eliminar un archivo para la subida de archivos opcionales
    const handleRemoveOptional = (file) => {
      const index = formState.optionalFiles.indexOf(file);
      const newFileList = formState.optionalFiles.slice();
      newFileList.splice(index, 1);
      formState.optionalFiles = newFileList;
    };

    // Agregar un archivo opcional al input
    const beforeUploadOptional = (file) => {
      if (formState.optionalFiles.length < 5) {
        const fileSize = file.size / 1024 / 1024;
        if (fileSize > 5) {
          message.error('El archivo excede el peso máximo 5MB');
        } else {
          formState.optionalFiles = [...formState.optionalFiles, file];
        }
      } else {
        message.error('Máximo archivos a subir es 5');
      }
      return false;
    };

    //* Modal
    const visible = ref(false);
    const showSucess = ref(false);
    const createdTicketId = ref(null);
    const modalStyle = reactive({
      title: '',
      text: '',
      cancelText: '',
      confirmText: '',
      successText: ''
    });

    const showModal = () => {
      formRef.value.validate().then(() => {
        visible.value = true;

        switch (formState.typeForm) {
          case '1':
            modalStyle.title = 'Baja de cargas masiva';
            modalStyle.text =
              '¿Estás seguro que deseas enviar una solicitud de baja masiva de cargas por archivo a la Compañía?';
            modalStyle.cancelText = 'Volver atrás';
            modalStyle.confirmText = 'Confirmar';
            modalStyle.successText =
              'Su solicitud de baja masiva de cargas por archivo a la Compañía ha sido enviada con éxito';
            break;

          default:
            console.warn(
              `Tipo de formulario desconocido: ${formState.typeForm}`
            );
        }
      });
    };

    const handleOk = () => {
      visible.value = false;
    };

    //* Validations
    const rules = {
      company: [
        {
          required: true,
          message: 'Seleccione una empresa',
          trigger: 'change',
          type: 'number'
        }
      ],
      insuranceCompany: [
        {
          required: true,
          message: 'Seleccione una compañía aseguradora',
          trigger: 'change',
          type: 'number'
        }
      ],
      docs: [
        {
          type: 'array',
          required: true,
          message: 'Seleccione al menos un formulario',
          trigger: 'change'
        }
      ],
      message: [
        {
          required: true,
          message: 'Ingrese un mensaje',
          trigger: 'change',
          type: 'string'
        }
      ],
      fileList: [
        {
          type: 'array',
          required: true,
          message: 'Adjunte un archivo',
          trigger: 'change'
        }
      ]
    };

    const insuranceCompanyFormType = computed(() => {
      return insurancesData.value.find(
        (company) => company.value === formState.insuranceCompany
      )?.formType;
    });

    const reportId = ref(null);
    const showReport = ref(false);
    const loadingReport = ref(false);

    const closeReportModal = () => {
      showReport.value = false;
    };
    const onCloseReport = () => {
      showReport.value = false;
    };

    const downloadReport = () => {
      loadingReport.value = true;
      try {
        const url = getMovementProcessedFile(reportId.value);
        const reportLink = document.createElement('a');
        reportLink.href = url;
        reportLink.download = 'reporte.xlsx';
        reportLink.click();
      } catch (e) {
        console.error('Error al formar la URL o descargar:', e);
      } finally {
        loadingReport.value = false;
      }
    };

    //* Actions
    const onSubmit = async () => {
      loading.value = true;
      const formData = new FormData();
      formData.append('brokerId', store.getters[GET_LOGGED_USER].id);
      formData.append('companyId', formState.company);
      formData.append('insuranceCompanyId', formState.insuranceCompany);
      if (formState.fileList.length > 0) {
        formData.append('file', formState.fileList[0]);
      }
      formData.append('typeForm', formState.typeForm);
      formData.append('message', formState.message);
      if (formState.optionalFiles.length > 0) {
        formState.optionalFiles.forEach((file) => {
          formData.append('optionalFiles', file);
        });
      }

      try {
        const res = await store.dispatch(
          POST_MASSIVE_DEPENDENTS_EXCLUSION,
          formData
        );

        if (res.status === 'success') {
          createdTicketId.value = res.ticketId;
          await delay(1000);
          openNotificationWithIcon(
            'success',
            'Correcto',
            'Ticket de baja de cargas masiva creado con éxito.'
          );
          showSucess.value = true;
          formRef.value.resetFields();
        } else if (res.status === 'error') {
          reportId.value = res.processedFileId;
          showReport.value = true;
        }
      } catch (error) {
        openNotificationWithIcon(
          'error',
          'Error',
          `Error al generar el ticket de baja masiva de cargas. ${
            error.response?.data?.message ||
            'No se pudo procesar la solicitud. Por favor, intenta nuevamente.'
          }`
        );
      } finally {
        loading.value = false;
        visible.value = false;
      }
    };

    return {
      //* Variables
      routes,
      dataOutput,
      companiesData,
      insurancesData,
      documentsData,
      documentURL,
      modalStyle,
      visible,
      formRef,
      formState,
      rules,
      loading,
      showSucess,
      createdTicketId,
      insuranceCompanyFormType,
      //* Methods
      handleChangeCompany,
      handleChangeInsurance,
      handleRemove,
      beforeUpload,
      showModal,
      handleOk,
      onSubmit,
      handleRemoveOptional,
      beforeUploadOptional,
      showNext,
      onCloseReport,
      downloadReport,
      closeReportModal,
      showReport,
      loadingReport,
      reportId
    };
  }
};
</script>
